// extracted by mini-css-extract-plugin
export default {"container":"NotificationLabel_container__VWqDW","error":"NotificationLabel_error__G0I5f","close":"NotificationLabel_close__q4phx"};